import { gql } from '__generated__/gql';

export const CREATE_COMMENT_ON_ASSIGNMENT_STEP = gql(/* GraphQL */ `
  mutation CreateCommentOnAssignmentStep($input: CreateCommentOnAssignmentStepInput!) {
    createCommentOnAssignmentStep(input: $input) {
      success
      error
      stepWithResponse {
        id
        step {
          id
          subject
          description
          startDate
          dueDate
          estimatedTimeToComplete
          actualTimeToComplete
          completedDate
          requiresReview
          isRequired
          activity {
            id
          }
          question {
            id
            questionDetail
            type
            options
            answer
          }
          assignedUser {
            id
            firstName
            lastName
          }
        }
        response {
          id
          actualTimeToComplete
          completedDate
          textAnswer
          assignedUser {
            id
            firstName
            lastName
          }
          completedByUser {
            id
            firstName
            lastName
          }
          answers {
            id
            question {
              id
            }
            selectedChoice {
              id
              label
              value
              pillarScore
            }
            supplementalTextAnswer
          }
        }
      }
    }
  }
`);
